export var AssetSelectionType;
(function (AssetSelectionType) {
    AssetSelectionType["NEW"] = "new";
    AssetSelectionType["EXISTING"] = "existing";
})(AssetSelectionType || (AssetSelectionType = {}));
export var HoldingClassSelectionType;
(function (HoldingClassSelectionType) {
    HoldingClassSelectionType["NEW"] = "new";
    HoldingClassSelectionType["EXISTING"] = "existing";
})(HoldingClassSelectionType || (HoldingClassSelectionType = {}));
export var FundingSource;
(function (FundingSource) {
    FundingSource["CapitalCall"] = "capitalCall";
    FundingSource["GeneralCapitalOnAccounts"] = "generalCapitalOnAccounts";
})(FundingSource || (FundingSource = {}));
export var InvestmentTypes;
(function (InvestmentTypes) {
    InvestmentTypes["InvestmentCreated"] = "lpInvestmentCreated";
    InvestmentTypes["InvestmentRealisedCurrencyGain"] = "lpInvestmentRealisedCurrencyGain";
    InvestmentTypes["InvestmentRealisedCurrencyLoss"] = "lpInvestmentRealisedCurrencyLoss";
})(InvestmentTypes || (InvestmentTypes = {}));
export var InvestmentRevaluationOption;
(function (InvestmentRevaluationOption) {
    InvestmentRevaluationOption["AllShares"] = "allShares";
    InvestmentRevaluationOption["ShareClassOnly"] = "shareClassOnly";
    InvestmentRevaluationOption["DoNotRevalue"] = "doNotRevalue";
    InvestmentRevaluationOption["ManuallyInput"] = "manuallyInput";
})(InvestmentRevaluationOption || (InvestmentRevaluationOption = {}));
//# sourceMappingURL=index.js.map